const TEST_IDS = {
  tokenTextField: 'borrow-modal-token-text-field',
  submitButton: 'submit-button',
  receiveNativeToken: 'borrow-modal-receive-native-token',
  availableAmount: 'available-amount',
};

export default TEST_IDS;
